import {
  Router,
  Route,
  IndexRoute,
  applyRouterMiddleware,
} from 'react-router';
import { useScroll } from 'react-router-scroll';
import React from 'react';
import CampaignUnsubscribe from './app/confirmation/CampaignUnsubscribe';
import { composeReplaceHooks, persistShowShops } from './app/utils/routes';
import {
  BarberVerifyEmail,
  CustomerVerifyEmail,
} from './app/confirmation/VerifyEmail';
import WaitingListTimes from './app/waitingList/containers/WaitingListTimes';
import WaitingListInfo from './app/waitingList/containers/WaitingListInfo';
import Receipt from './app/receipt/Receipt';
import RemoveFromWaitingList from './app/confirmation/RemoveFromWaitingList';
import App from './app/index';
import DynamicBooking from './app/dynamicBooking/routes';
import KioskRoutes from './app/kiosk/routes';
import BrandRoutes from './app/brands/routes';
import GiftCardRoutes from './app/giftCard/routes';
import NotificationsRoutes from './app/notifications/routes';
import Layout from './app/components/Layout';
import MainLayout from './app/components/MainLayout';
import OldRoutes from './OldRoutes';
import ReservationCanceled from './app/reservation/ReservationCanceled';
import ResetPassword from './app/confirmation/ResetPassword';
import MobileAppLinkRedirect from './app/mobileApp/containers/MobileAppLinkRedirect';
import DeepLinkRedirect from './app/mobileApp/containers/DeepLinkRedirect';
import Route404 from './app/components/Route404';
import ShopSecondaryLayout from './app/components/ShopSecondaryLayout';
import Shops from './app/shops/Shops';
import ConfirmBarber from './app/confirmation/ConfirmBarber';
import ViewReservation from './app/reservation/ViewReservation';
import ReschedulePickTime from './app/reservation/containers/PickTime';
import WaitingListBook from './app/confirmation/WaitingListBook';
import CampaignEmail from './app/campaign/containers/CampaignEmail';
import CheckoutContainer from './app/reservation/containers/CheckoutContainer';
import MembershipRoutes from './app/membership/routes';
import { history } from './history';

const scrollMiddleware = useScroll((prevRouterProps, { routes }) => !routes.some(route => route.ignoreScrollBehavior));

export default onRouteUpdate => (
  <Router
    history={history}
    render={applyRouterMiddleware(scrollMiddleware)}
    onUpdate={onRouteUpdate}
  >
    <Route path="/receipt/:id/:transactionIdentifier" component={Receipt} />
    <Route path="/campaign/:campaignId/:source(/:customerId)" component={CampaignEmail} />
    <Route path="/" component={App} onChange={composeReplaceHooks(persistShowShops)}>
      <Route component={Layout}>
        <Route path="verify-email/customer/:token" component={CustomerVerifyEmail} />
        <Route path="verify-email/barber/:token" component={BarberVerifyEmail} />
        <Route path="confirm/:shopId/:barberId" component={ConfirmBarber} />
        <Route path="reset-password/:token" component={ResetPassword} />
        <Route path="app-link" component={MobileAppLinkRedirect} />
        <Route path="apps/confirmation/:confirmationCode" component={DeepLinkRedirect} />
        <Route path="apps/:brandRoute/confirmation/:confirmationCode" component={DeepLinkRedirect} />
        <Route path="customer/waiting-list/:customerId" component={RemoveFromWaitingList} />
        <Route path="unsubscribe/campaign/:ownerType/:ownerId(/:customerId)" component={CampaignUnsubscribe} />
        <Route path="404" component={Route404} status={404} />
      </Route>
      <Route component={MainLayout}>
        <IndexRoute component={Shops} />
      </Route>
      { BrandRoutes() }
      { KioskRoutes() }
      { GiftCardRoutes() }
      { NotificationsRoutes() }
      { MembershipRoutes() }
      <Route component={ShopSecondaryLayout}>
        <Route path="view-reservation/:appointmentId/charge" component={CheckoutContainer} />
        <Route path="view-reservation/:appointmentId" component={ViewReservation}>
          <Route path="reschedule" component={ReschedulePickTime} />
        </Route>
        <Route path="appointment-canceled/:appointmentId" component={ReservationCanceled} />
        <Route path="book-time-slot/:waitingListSlotId/:waitingListCustomerId" component={WaitingListBook} />
        <Route path="waiting-list" component={WaitingListInfo} />
        <Route
          path="waiting-list-times/:waitingListCustomerId/:slotId"
          component={WaitingListTimes}
        />
      </Route>
      { DynamicBooking() }
      { OldRoutes() }
      <Route component={Layout}>
        <Route path="*" component={Route404} status={404} />
      </Route>
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes.jsx